module.exports = __webpack_public_path__ + "img/scholtze.7fdd39d5.jpg";